<template>
  <div class="my-20">
    <HeaderBar :title="hTitle" />
    <div class="flex justify-center">
      <div class="w-full p-2 h-screen">
        <iframe
          class="w-full h-screen"
          src="docs/ListOfPaymentFac_compressed.pdf"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import HeaderBar from "../../components/HeaderBar.vue";
import Table2Col from "../../components/Table2Col.vue";
import UlList from "../../components/UlList.vue";
export default {
  props: ["hTitle"],
  components: { HeaderBar, Table2Col, UlList },
  data() {
    return {
      tableList: [
        {
          a: "PAYMENT FOR",
          b: "MOLDEX REALTY, INC.",
        },
        {
          a: "CLIENT NAME",
          b: "principal buyer's name",
        },
        {
          a: "MODE OF PAYMENT",
          b: "choose if cash or check",
        },
        {
          a: "REFERENCE NUMBER",
          b: "buyer’s contract number",
        },
        {
          a: "DETAILS",
          b: "details of payment",
        },
        {
          a: "Always send proof of payment to billing@moldex.com.ph",
          b: "",
        },
      ],
      tableList2: [
        {
          a: "ACCOUNT NAME",
          b: "principal buyer's name",
        },
        { a: "BILLER", b: "MOLDEX REALTY, INC." },
        { a: "DATE", b: "indicate date" },
        { a: "AMOUNT DUE", b: "indicate amount" },
        { a: "ACCOUNT NUMBER", b: "buyer’s contact number" },
        { a: "Always send proof of payment to billing@moldex.com.ph", b: "" },
      ],
      ulList: [
        {
          li: "Click Select Biller",
          id: 1,
        },
        {
          li: "Click Pay Bills at the middle bottom of your screen",
          id: 2,
        },
        {
          li: "On the 'Biller list' tab, look for 'MOLDEX REALTY INC'",
          id: 3,
        },
        {
          li: "Provide the necessary details",
          id: 4,
        },
        {
          li: "Provide the necessary payment detailsr",
          id: 5,
        },
      ],
      ulList2: [
        { li: "Launch or open the Bayad App", id: 1 },
        { li: "Login to your Bayad App Account", id: 2 },
        { li: "Tap 'Pay Bills' in the Services Menu'", id: 3 },
        { li: "In the 'BILLERS' category, tap 'REAL ESTATE'", id: 4 },
        { li: "Select 'MOLDEX REALTY INC'", id: 5 },
        { li: "Input the necessary details", id: 6 },
        {
          li: "<ul class='list-disc'><li>Contact Number (This is your 13-digit banking or contact number) </li><li>Amount Due</li></ul>",
          id: 7,
        },
        {
          li: "You will receive a confirmation from Bayad via your registered mobile number about the details of the payment you made",
          id: 8,
        },
        {
          li: "Do not forget to take a screenshot of your proof of payment and send it to billing@moldex.com.ph",
          id: 9,
        },
      ],
      ulList3: [
        {
          li: "Search: Moldex Realty, Inc.",
          id: 1,
        },
        {
          li: "Use buyer’s 13-digit contract number",
          id: 2,
        },
      ],
      ulList4: [
        { li: "Direct payment link: https://pay.aqwire.io/moldex", id: 1 },
        { li: "Accepts major local and international credit cards", id: 2 },
        { li: "Use your 13-digit GIS reservation number", id: 3 },
      ],
    };
  },
};
</script>